@import 'src/styles/common/_colors.scss';
.searchContainer {
	.searchWrapper {
		position: relative;
		input {
			box-shadow: inset 0 0 15px 0 $black;
			background: $black;
			margin-right: 10px;
			margin-bottom: 0;
			border-radius: 10px;
			border-color: $black;
			border-style: solid;
			border-width: 3px;
			font-size: 12px;
			font-weight: 600;
			color: $white;
			width: 198px;
			height: 29px;
			padding-left: 30px;
			padding-right: 22px;
			outline: 0;		
			&.inputActive{
				color: $white;
				background-color: $dark-green;
				box-shadow: initial;
			}
			&.floatingSearch{
				height: 35px;
			}
			&:focus {
				background-color: $white;
				box-shadow: inset 0 0 3px 0 $green-variant-2;
				outline: 0;
				border: 3px solid $green-variant-2;
				color: $black;
			}
		}

		.clearInput {
			right: 20px;
			top: 18px;
			position: absolute;
			margin-top: -5px;
			cursor: pointer;
			color: $gray-variant-9;
		}

		.iconSearch {		
			left: 8px;
			position: absolute;
			cursor: pointer;
			color: $gray-variant-9;
			font-size: 16px;
			top: 11px;	
		}

		.icon {
			/* use !important to prevent issues with browser extensions that change fonts */
			font-family: 'icomoon' !important;
			font-style: normal;
			font-weight: normal;
			font-variant: normal;
			text-transform: none;
			line-height: 1;
		
			/* Better Font Rendering =========== */
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;
		}

		.iconSearch:before {
			content: "\e603";
		}
		
		.iconClear:before {
			content: "\e018";
		}
		
		
	}
}

